<template>
  <div class="step step_1">
    <h3 class="title-step whiteTitle">
      START CREATING <br />
      YOUR DRAWINGS
    </h3>
    <div class="description-step">
      <ul>
        <li>Choose your <span class="destacar">creation length</span></li>
        <div class="length">
          <p><Icon icon="fluent:note-24-filled" />Single Drawing</p>
          <p><Icon icon="fluent:layer-24-filled" />Pixel Collection</p>
        </div>
        <li>
          <span class="destacar"> Get creative!</span> Personalize it as you
          prefer
        </li>
        <li>
          <span class="destacar"> Name it and send it</span> to the PixelGRID
          display
        </li>
      </ul>
    </div>
    <h6>
      NEED MORE HELP
      <br />
      <Icon class="swipe" icon="fluent:swipe-right-24-filled" />
    </h6>
  </div>
</template>

<script>
import { Icon } from "@iconify/vue2";
export default {
  name: "info-component",
  components: {
    Icon,
  },
};
</script>

<style>
.step_1 .whiteTitle {
  font-size: 18px;
  color: #fff;
}
.step {
  width: 100vw;
}

.step_1 h6 {
  font-family: "Press Start 2P";
  text-align: center;
  font-size: 12px;
  color: #fff;
  margin-bottom: 0px;
}

.step_1 h6 .swipe {
  font-size: 28px;
  margin: 5px 0px 0px 0px;
}

.description-step ul {
  padding-inline-start: 0px !important;
}

.description-step li:first-child {
  margin-bottom: 15px;
}

.description-step li {
  margin-bottom: 25px;
  list-style: none;
}

.description-step li:before {
  content: "•";
  font-size: 10px;
  margin-right: 4px;
}

.description-step li span {
  color: #f7c544;
}

.description-step .length {
  margin-left: 20px;
  margin-bottom: 25px;
}

.description-step .length p {
  display: flex;
  align-items: center;
}

.description-step .length .iconify {
  margin-right: 10px;
  font-size: 20px;
  align-self: center;
}
</style>
